/*jshint esversion: 6 */
import Vue from 'vue';
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
//types:

  //custom template
  sfolders: {},
  //sequences
  //custom template
  sequences: {},
  //community template
  csequences: {},
  //business template
  bsequences: {},

//waggons
  wagfolders: {},
  //custom
  waggons: {},
  //custom seqence
  swaggons: {},
  //community seqence
  cswaggons: {},
  //business seqence
  bswaggons: {},
  //business waggon
  bwaggons: {},
  //community waggon
  cwaggons: {},

//work_packages
  wfolders: {},
  //custom template
  workpackages: {},
  //custom sequence
  sworkpackages: {},
  //community template
  cworkpackages: {},
  //community sequence
  csworkpackages: {},
  //business template
  bworkpackages: {},
  //business sequence
  bsworkpackages: {},
  // custom waggon
  wagworkpackages: {},
  // business waggon
  bwagworkpackages: {},
  // community waggon
  cwagworkpackages: {},

//Steps
  //custom template
  worksteps: {},
  defectsteps: {},
  qualitysteps: {},
  handoversteps: {},
  logisticsteps: {},
  designsteps: {},
  materialsteps: {},
  machinesteps: {},

  //custom workpackage
  wworksteps: {},
  wdefectsteps: {},
  wqualitysteps: {},
  whandoversteps: {},
  wlogisticsteps: {},
  wdesignsteps: {},
  wmaterialsteps: {},
  wmachinesteps: {},

  //custom sequence
  sworksteps: {},
  sdefectsteps: {},
  squalitysteps: {},
  shandoversteps: {},
  slogisticsteps: {},
  sdesignsteps: {},
  smaterialsteps: {},
  smachinesteps: {},

  //community template
  cworksteps: {},
  cdefectsteps: {},
  cqualitysteps: {},
  chandoversteps: {},
  clogisticsteps: {},
  cdesignsteps: {},
  cmaterialsteps: {},
  cmachinesteps: {},

  //community workpackage
  cwworksteps: {},
  cwdefectsteps: {},
  cwqualitysteps: {},
  cwhandoversteps: {},
  cwlogisticsteps: {},
  cwdesignsteps: {},
  cwmaterialsteps: {},
  cwmachinesteps: {},

  //community sequence
  csworksteps: {},
  csdefectsteps: {},
  csqualitysteps: {},
  cshandoversteps: {},
  cslogisticsteps: {},
  csdesignsteps: {},
  csmaterialsteps: {},
  csmachinesteps: {},

  //business template
  bworksteps: {},
  bdefectsteps: {},
  bqualitysteps: {},
  bhandoversteps: {},
  blogisticsteps: {},
  bdesignsteps: {},
  bmaterialsteps: {},
  bmachinesteps: {},

  //business workpackage
  bwworksteps: {},
  bwdefectsteps: {},
  bwqualitysteps: {},
  bwhandoversteps: {},
  bwlogisticsteps: {},
  bwdesignsteps: {},
  bwmaterialsteps: {},
  bwmachinesteps: {},

  //business sequence
  bsworksteps: {},
  bsdefectsteps: {},
  bsqualitysteps: {},
  bshandoversteps: {},
  bslogisticsteps: {},
  bsdesignsteps: {},
  bsmaterialsteps: {},
  bsmachinesteps: {},

  //custom waggon
  wagworksteps: {},
  wagdefectsteps: {},
  wagqualitysteps: {},
  waghandoversteps: {},
  waglogisticsteps: {},
  wagdesignsteps: {},
  wagmaterialsteps: {},
  wagmachinesteps: {},

  //bustiness waggon
  bwagworksteps: {},
  bwagdefectsteps: {},
  bwagqualitysteps: {},
  bwaghandoversteps: {},
  bwaglogisticsteps: {},
  bwagdesignsteps: {},
  bwagmaterialsteps: {},
  bwagmachinesteps: {},

  //community waggon
  cwagworksteps: {},
  cwagdefectsteps: {},
  cwagqualitysteps: {},
  cwaghandoversteps: {},
  cwaglogisticsteps: {},
  cwagdesignsteps: {},
  cwagmaterialsteps: {},
  cwagmachinesteps: {},

  // materials
  mfolders: {},
  bmaterials: {},
  cmaterials: {},
  materials: {},
  propertysets: {},
  properties: {},

//images
  //custom workpackage
  wworkpackageimages: {},
  //custom waggon
  wagworkpackageimages: {},
  //custom sequence
  sworkpackageimages: {},
  //community workpackage
  cworkpackageimages: {},
  cwworkpackageimages: {},

  //community sequence
  csworkpackageimages: {},
  //business workpackage
  bworkpackageimages: {},
  bwworkpackageimages: {},

  //business sequence
  bsworkpackageimages: {},


  // AI
  workpackagerecommendations: {},
  sworkpackagerecommendations: {},
  swaggonrecommendations: {},

  // etc
  all_loaded: [],
  error: '',
  cache: {},
  search: {}
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getWBObjects: (state) => (payload) => {
    if (payload.ids) {
      return payload.ids.map(id => state[payload.type][id]);
    } else if (payload.types) {
      let array = [];
      payload.types.forEach(type => {
        array = array.concat(Object.keys(state[type]).map(id => state[type][id]));
      });
      return array;
    } else {
      return Object.keys(state[payload.type]).map(id => state[payload.type][id]);
    }
  },
  getWBObjectsSearch: (state, getters, rootState) => (payload) => {
    // console.log("JAAAAA", payload,rootState.WorkBenchLocal.workbench_variables.search, state.search, payload.prefix + payload.object_type)
    let array = [];
    if(rootState.WorkBenchLocal.workbench_variables.search != '' && state.search[payload.prefix + payload.object_type]) {
      state.search[payload.prefix + payload.object_type].forEach(id => {
        // console.log("NEIN", id, state.search)
        if(payload.folder) {
          // console.log(payload.prefix + payload.object_type, payload.folder)
          if (payload.folder == 'last-updated'){
            if (!rootState.WorkBenchLocal.workbench_variables.search_all) {
              if (!state[payload.prefix + payload.object_type][id][payload.prefix + payload.object_type_short + "folder"]) {
                array.push(state[payload.prefix + payload.object_type][id])
              }
            } else {
              let folder = JSON.parse(JSON.stringify(state[payload.prefix + payload.object_type][id][payload.prefix + payload.object_type_short + "folder"]))
              let obj = JSON.parse(JSON.stringify(state[payload.prefix + payload.object_type][id]))
              while (folder) {
                  if(!state[payload.prefix + payload.object_type_short + "folders"][folder.id][payload.prefix + payload.object_type_short + "folder"]){
                    folder = null
                    continue
                  }
                  let next_folder_id = state[payload.prefix + payload.object_type_short + "folders"][folder.id][payload.prefix + payload.object_type_short + "folder"].id
                  let next_folder = JSON.parse(JSON.stringify(state[payload.prefix + payload.object_type_short + "folders"][next_folder_id]))
                  next_folder.name += '/' + folder.name
                  // console.log(folder, next_folder)
                  folder = next_folder 
              }
              array.push(obj)
            }
          }
          else if (!rootState.WorkBenchLocal.workbench_variables.search_all) {
            if (state[payload.prefix + payload.object_type][id][payload.prefix + payload.object_type_short + "folder"] && state[payload.prefix + payload.object_type][id][payload.prefix + payload.object_type_short + "folder"].id == payload.folder) {
              array.push(state[payload.prefix + payload.object_type][id])
            }
          }
          else {
            let folder = JSON.parse(JSON.stringify(state[payload.prefix + payload.object_type][id][payload.prefix + payload.object_type_short + "folder"]))
            let obj = JSON.parse(JSON.stringify(state[payload.prefix + payload.object_type][id]))
            while (folder) {
              if (folder.id == payload.folder) { 
                obj[payload.prefix + payload.object_type_short + "folder"].name = folder.name
                array.push(obj)
                folder = null
              } else {
                // console.log(folder, payload.prefix + payload.object_type_short + "folder", state)
                if(!state[payload.prefix + payload.object_type_short + "folders"][folder.id][payload.prefix + payload.object_type_short + "folder"]){
                  folder = null
                  continue
                }
                let next_folder_id = state[payload.prefix + payload.object_type_short + "folders"][folder.id][payload.prefix + payload.object_type_short + "folder"].id
                let next_folder = JSON.parse(JSON.stringify(state[payload.prefix + payload.object_type_short + "folders"][next_folder_id]))
                next_folder.name += '/' + folder.name
                // console.log(folder, next_folder)
                folder = next_folder 
              }
            }
          }
        } else {
          array.push(state[payload.prefix + payload.object_type][id])
        }
      })
      
    } else {
      // console.log(payload.prefix + payload.object_type, payload.folder, state, 'hier')
      // console.log(JSON.parse(JSON.stringify(state[payload.prefix + payload.object_type])), 'OBJECT')
      Object.values(state[payload.prefix + payload.object_type]).forEach(obj => {
        if(payload.folder) {
          if (payload.folder == 'last-updated'){
            if (!obj[payload.prefix + payload.object_type_short + "folder"]) {
              array.push(obj)
            }
          }
          else if (obj[payload.prefix + payload.object_type_short + "folder"] && obj[payload.prefix + payload.object_type_short + "folder"].id == payload.folder ) {
            array.push(obj)
          }
        } else {
          array.push(obj)
        }
      })
    }
    // console.log(array, 'ergebnis', payload)
    return array
  },
  getParentFolders: (state, getters) => (payload) => {

      if(!payload.parents){
        payload.parents = [];
      }

      if(payload.wb_object[payload.type] === null) {
        return payload.parents;
      }

      payload.parents.push(payload.wb_object[payload.type]);
      payload.wb_object = state[payload.type + 's'][payload.wb_object[payload.type].id];
      return getters.getParentFolders(payload);
  },
  getWBObjectsFiltered: (state) => (payload) => {
    let array = [];
    if (payload.ids) {
      array = payload.ids.map(id => state[payload.type][id]);
    } else if (payload.types) {
      payload.types.forEach(type => {
        // if (payload.workbench && ['csequences', 'cworkpackages'].includes(type)) {
        //   array = array.concat(Object.keys(state[type])
        //     .map(id => state[type][id])
        //     .filter(object => object.likes.findIndex(like => like.user.id === rootGetters['Auth/getUserId']) !== -1
        //   ));
        // } else {
          array = array.concat(Object.keys(state[type]).map(id => state[type][id]));
        // }
      });
    } else {
      array = Object.keys(state[payload.type]).map(id => state[payload.type][id]);
    }
    return array.filter(object => {
      let boolean = true;

      // folder (TODO: sfolder is currently hard coded -> should be dynamic in the future)
      if(payload.folder) {
        // all objects that do not have a folder
        if(payload.folder === 'last-updated') {
          if(object.sfolder){
            return false;
          }
        } else {
          // payload.folder is a folder id
          if( object.sfolder === null || (object.sfolder && object.sfolder.id !== payload.folder)){
            return false;
          }
        }
      }

      if (payload.search) {
        boolean = false;
      }
      for (let prop in payload.search) {
        if (prop === 'hashtag') {
          object.hashtags.forEach(hashtag => {
            if (hashtag.tag.toLowerCase().includes(payload.search[prop].toLowerCase())) {
              boolean = true;
            }
          });
        }
        else if (object[prop].toLowerCase().includes(payload.search[prop].toLowerCase())) {
          boolean = true;
        }
      }
      for (let prop in payload.filter) {
        if (prop === 'owner' && object[prop].id !== payload.filter[prop].id) {
          boolean = false;
        } else if (prop !== 'owner' && object[prop] !== payload.filter[prop]) {
          boolean = false;
        }
      }
      return boolean;
    });
  },
  getWBObject: (state) => (payload) => {
    return state[payload.type][payload.id];
  },
  getUrl: (state, getters, rootState, rootGetters) => (payload) => {
    let url = '';
    if (!payload.template_type) {
      if (Object.keys(payload.url[0])[0].substring(0, 1) === 'c') {
        url = 'community';
      }
      if (Object.keys(payload.url[0])[0].substring(0, 1) === 'b') {
        url = `businesses/${rootGetters['Auth/getUser'].business.id}`;
      }
    } else {
      if (payload.template_type === 'community') {
        url = 'community';
      }
      if (payload.template_type === 'company') {
        url = `businesses/${rootGetters['Auth/getUser'].business.id}`;
      }
    }
    // payload.url.forEach(entry => {
    //   if (entry.type === 'entity') {
    //     url = `${url}/${Object.keys(entry)[0]}${Object.values(entry)[0] !== ''?`/${Object.values(entry)[0]}`:''}`
    //   }
    //   if (entry.type === 'first_query') {
    //     url = `${url}?${Object.keys(entry)[0]}=${Object.values(entry)[0]}`
    //   }
    //   if (entry.type === 'query') {
    //     url = `${url}&${Object.keys(entry)[0]}=${Object.values(entry)[0]}`
    //   }
    // });
    payload.url.forEach(entry =>
      url = `${url}${Object.keys(entry)[0].substring(0, 4) !== 'show'? '/':'?show='}${Object.keys(entry)[0]}${Object.values(entry)[0] !== ''?`/${Object.values(entry)[0]}`:''}`
    );
    if (payload.url_suffix) {
      url = `${url}${payload.url_suffix}`;
    }
    return url;
  },
  getAISequenceWaggons: (state) => (payload) => {
    if (state[`${payload.prefix}sequences`][payload.sequence_id]){
      let waggons = JSON.parse(JSON.stringify(state[`${payload.prefix}sequences`][payload.sequence_id][`${payload.prefix}swaggons`].map(id => state[`${payload.prefix}swaggons`][id])));
      for (let i = 0; i < waggons.length; i++) {
        waggons[i].position = i + parseInt(1);
        waggons[i][`${payload.prefix}sworkpackages`] = waggons[i][`${payload.prefix}sworkpackages`].map(id => (
          {
            color: state[`${payload.prefix}sworkpackages`][id].color,
            token: state[`${payload.prefix}sworkpackages`][id].token,
            icon: state[`${payload.prefix}sworkpackages`][id].icon
          }
        ));
      }
      if (payload.complete_sequence) {
        return {
          sequence_id: payload.sequence_id,
          swaggons: waggons
        };
      } else {
        let index = waggons.findIndex(waggon => waggon.id === payload.waggon_id);
        return {
          prev_waggon: index > 0? waggons[index-1]:{},
          curr_waggon: waggons[index],
          next_waggon: index < waggons.length-1?waggons[index+parseInt(1)]:{}
        };
      }
    }
  },
  getSequenceWorkpackageColors: (state) => (payload) => {
    let colors = [];
    let waggons = [];
    if (payload.local) {
      waggons = payload.swaggons;
    } else {
      waggons = payload.swaggons.map(id => state[`${payload.prefix}swaggons`][id]);
    }
    waggons.forEach((waggon) => {
      let workpackages = [];
      if (payload.local) {
        workpackages = waggon.sworkpackages;
      } else {
        workpackages = waggon[`${payload.prefix}sworkpackages`].map(id => state[`${payload.prefix}sworkpackages`][id]);
      }
      workpackages.forEach(workpackage => {
        if (colors.findIndex(color => color.value === workpackage.color) === -1) {
          colors.push({
            value: workpackage.color,
            tooltip: workpackage.color,
          });
        }
      });
    });
    return colors;
  },
  getSequenceWorkpackageIcons: (state) => (payload) => {
    let icons = [];
    let waggons = [];
    if (payload.local) {
      waggons = payload.swaggons;
    } else {
      waggons = payload.swaggons.map(id => state[`${payload.prefix}swaggons`][id]);
    }
    waggons.forEach((waggon) => {
      let workpackages = [];
      if (payload.local) {
        workpackages = waggon.sworkpackages;
      } else {
        workpackages = waggon[`${payload.prefix}sworkpackages`].map(id => state[`${payload.prefix}sworkpackages`][id]);
      }
      workpackages.forEach(workpackage => {
        if (icons.findIndex(icon => icon.value === workpackage.icon) === -1) {
          icons.push({
            icon: workpackage.icon,
            value: workpackage.icon,
            tooltip: workpackage.icon,
            color: 'grey darken-1',
            wp_icon: true,
          });
        }
      });
    });
    return icons;
  },
  getWorkpackagesMaxChildren: (state, getters) => (payload) =>{
    let max = {
      steps: 0,
      images: 0,
    };
    let work_packages = [];
    if (payload.sequence_preview) {
      work_packages = getters.getWBObjects({types: ['sworkpackages', 'csworkpackages', 'bsworkpackages']});
    } else {
      work_packages = getters.getWBObjects({types: ['workpackages', 'cworkpackages', 'bworkpackages']});
    }
    work_packages.forEach(work_package => {
      let prefix = '';
      let steps = 0;
      switch (work_package.template_type) {
        case 'custom':
          break;
        case 'business':
          prefix = 'b';
          break;
        case 'community':
          prefix = 'c';
          break;
      }
      ['work', 'defect', 'quality', 'handover', 'logistic', 'design'].forEach(type => {
          steps = steps + work_package[`${prefix}w${type}steps`].length;
      });
      if (steps > max.steps) {
        max.steps = steps;
      }
      if (work_package[`${prefix}wworkpackageimages`].length > max.images) {
        max.images = work_package[`${prefix}wworkpackageimages`].length;
      }
    });
    return max;
  },
  getSequenceStatistics: (state, getters, rootState) => (payload) => {
    let statistic_settings = rootState.WorkBenchLocal.sequence_editor_variables.statistic_settings;
    let statistics = {max_waggon_sum: 0, waggon_values: []};
    let waggon_sum = 0;
    let values = [];
    let waggons = [];
    if (payload.local) {
      waggons = payload.swaggons;
    } else {
      waggons = payload.swaggons.map(id => state[`${payload.prefix}swaggons`][id]);
    }
    waggons.forEach((waggon, waggon_index) => {
      let workpackages = [];
      if (payload.local) {
        workpackages = waggon.sworkpackages;
      } else {
        workpackages = waggon[`${payload.prefix}sworkpackages`].map(id => state[`${payload.prefix}sworkpackages`][id]);
      }
      //is cumulative?
      if (statistic_settings.cumulative && waggon_index > 0) {
        waggon_sum = statistics.waggon_values[waggon_index-1].waggon_sum;
        values = [];
        getters.getSequenceWorkpackageColors(payload).forEach((color, index) => {
          values.push({
            value: statistics.waggon_values[waggon_index-1].values[index].value,
            color: color.value,
          });
        });
      } else {
        waggon_sum = 0;
        values = [];
        getters.getSequenceWorkpackageColors(payload).forEach(color => {
          values.push({
            value: 0,
            color: color.value,
          });
        });
      }
      workpackages.forEach(workpackage => {
        let addition = 0;
        if (statistic_settings.value === 'duration_planned' && workpackage.manpower_planned !== 0) {
          addition = Math.round((workpackage.time_effort_planned/workpackage.manpower_planned)*100) / 100;
        }
        else if (statistic_settings.value === 'time_effort_actual') {
          addition = Math.round((workpackage.duration_actual*workpackage.manpower_actual)*100) / 100;
        }
        else if (statistic_settings.value === 'workpackages') {
          addition = 1;
        }
        else {
          // if steps/images loaded
          if (!Object.keys(workpackage).includes(statistic_settings.value) && statistic_settings.value.includes('_count')) {
            // addition = workpackage[payload.prefix+statistic_settings.value.substring(0, statistic_settings.value.length-6)].length;
            addition = workpackage[`${payload.prefix}${statistic_settings.value.substring(0, statistic_settings.value.length-6)}_count`];
          }
          else {
            if ( statistic_settings.value.includes('step') ) {
              addition = workpackage[payload.prefix+statistic_settings.value];
            } else {
              addition = workpackage[statistic_settings.value];
            }
          }
        }
        if (isNaN(parseInt(addition))) {
          addition = 0;
        }
        values[values.findIndex(value => value.color === workpackage.color)].value += addition;
        waggon_sum = waggon_sum + addition;
      });
      //update max_waggon_sum
      if (waggon_sum > statistics.max_waggon_sum) {
        statistics.max_waggon_sum = waggon_sum;
      }
      // write waggon_value
      statistics.waggon_values.push({waggon_sum: waggon_sum, values: values});
    });
    return statistics;
  },
  isWBObjEmpty: (state) => (payload) => {
    return Object.entries(state[payload]).length <= 1;
  },
  getCache: (state) => { return state.cache; }
};

// Actions
const actions = {
  requestWBObject({ commit, getters, rootState }, payload) {
    return new Promise((resolve, reject) => {
      let url = getters.getUrl(payload);
      if ( getters.getCache[url] && new Date().getTime() < getters.getCache[url].time_expired ) {
        resolve();
      } else {
        axios({
          url: url,
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(resp => {
          payload.resp_data = resp.data.data;
          commit('create_wb_objects', {rootState, payload});
          commit('set_wb_object_search', payload);
          commit('View/set_meta_data', resp.data.meta_data, { root: true });
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          reject();
        });
      }
    });
  },
  createWBObject({commit, getters, rootState}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: getters.getUrl(payload),
        method: 'POST',
        data: payload.wb_object,
        headers: {
          'Cache-Control': 'no-cache'
        },
      })
      .then(resp => {
        payload.resp_data = resp.data.data;
        commit('create_wb_objects', {rootState, payload});
        if (payload.url.length > 2) {

          let target_key = Object.keys(payload.url[payload.url.length-2])[0];
          if (payload.resp_data[target_key].length > 1) {
            for (var i = 0; i < payload.resp_data[target_key].length; i++) {
              commit('add_wb_object', {
                wb_object: payload.resp_data[target_key][i],
                resp_data: { [target_key]: [payload.resp_data[target_key][i]] },
                url: payload.url
              });
            }
          } else {
            commit('add_wb_object', payload);
          }
        }
        if (payload.url.length > 1) {
          if (resp.data.data[Object.keys(payload.url[payload.url.length-2])][0].id) {
            resolve(resp.data.data[Object.keys(payload.url[payload.url.length-2])][0].id);
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        const ignore_string = "The connection timed out after 10 sec while awaiting incoming data";
        if (!err.response?.data?.error_msg || !err.response.data.error_msg.includes(ignore_string)) {
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        }
        reject();
      });
    });
  },
  updateWBObject({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: getters.getUrl(payload),
        method: 'PUT',
        data: payload.update
      })
      .then(() => {
        commit('update_wb_object', payload);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  updateWBObjectHashtags({commit, getters}, payload) {
      axios({
        url: getters.getUrl(payload) + '/hashtags',
        method: 'PUT',
        data: payload.update
      })
      .then(() => {
        commit('update_wb_object', payload);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      });
  },
  deleteWBObject({commit, getters}, payload) {
    axios({
      url: getters.getUrl(payload),
      method: 'DELETE',
      headers: {
        'Cache-Control': 'no-cache'
      },
    })
    .then(() => {
      if (payload.url.length > 1) {
        commit('remove_wb_object', payload);
      }
      commit('delete_wb_object', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  changeWBObjectPosition({commit, getters}, payload) {
    // commit before call due to performance
    return new Promise((resolve, reject) => {
      commit('change_wb_object_position', payload);
      axios({
        url: getters.getUrl(payload),
        method: 'PUT',
        data: payload.target
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  changeWBObjectParent({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: getters.getUrl(payload),
        method: 'PUT',
        data: payload.update
      })
      .then(() => {
        commit('change_wb_object_parent', payload);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  changeWBObjectFolder({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: getters.getUrl(payload),
        method: 'PUT',
        data: payload.update
      })
      .then(() => {
        commit('change_wb_object_folder', payload);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });

  },
  exportMasterialCSV({commit, rootGetters}, payload) {
    let axios_url = '';
    let material_type = '';

    if(payload === 'company'){
      axios_url = `businesses/${rootGetters['Auth/getUser'].business.id}/bmaterials/0/exportmaterialcsv`;
      material_type = 'company';
    } else if(payload === 'custom'){
      axios_url = 'materials/0/exportmaterialcsv';
      material_type = 'user';
    }

    axios({
      url: axios_url,
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const date = new Date();
        const string = `material_${material_type}_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}_${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}.zip`;

        link.setAttribute('download', string);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        commit('View/set_user_feedback', err, { root: true });
      });
  },

  exportWorkpackageCSV({commit, rootGetters}, payload) {
    let axios_url = '';
    let workpackage_type = '';

    if(payload === 'company'){
      axios_url = `businesses/${rootGetters['Auth/getUser'].business.id}/bworkpackages/0/exportBWorkpackageCSV`;
      workpackage_type = 'company';
    } else if(payload === 'custom'){
      axios_url = 'workpackages/0/exportWorkpackageCSV';
      workpackage_type = 'user';
    }

    axios({
      url: axios_url,
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const date = new Date();
        const string = `workpackage_${workpackage_type}_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}_${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}.zip`;

        link.setAttribute('download', string);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        commit('View/set_user_feedback', err, { root: true });
      });
  },
  addLoadAll({commit}, type){
    commit('add_load_type', type);
  },
  resetSearch({commit, dispatch}){
    dispatch('WorkBenchLocal/updateWBLObject', {
      path: [
        {workbench_variables: ''}
      ],
      update: {
        search: ''
      }
    }, { root: true })
    commit('reset_search')
  }
};

// Mutations
const mutations = {
  //object mutations
  create_wb_objects(state, {rootState, payload}) {
    let state_copy = rootState.WorkBench;
    for (let prop in payload.resp_data) {
      payload.resp_data[prop].forEach(object => {
        if (state_copy[prop][object.id]) {
          Vue.set(state_copy[prop], object.id, Object.assign(state_copy[prop][object.id], object));
        } else {
          Vue.set(state_copy[prop], object.id, object);
        }
      });
    }
    rootState.WorkBench = state_copy;
  },
  set_wb_object_search(state, payload) {
    // let search = {}
    Object.keys(payload.resp_data).forEach(object_key => {
      state.search[object_key] = payload.resp_data[object_key].map(element => element.id)
    })
    // console.log(state)
  },
  reset_search(state){
    state.search = {}
  },
  update_wb_object(state, payload){
    if (['like', 'unlike'].includes(Object.keys(payload.url[payload.url.length-1])[0])) {
      Object.assign(state[Object.keys(payload.url[payload.url.length-2])[0]][Object.values(payload.url[payload.url.length-2])[0]], payload.update);
    } else {
      Object.assign(state[Object.keys(payload.url[payload.url.length-1])[0]][Object.values(payload.url[payload.url.length-1])[0]], payload.update);
    }
  },
  delete_wb_object(state, payload) {
    let deleted_object_key = Object.keys(payload.url[payload.url.length-1])[0];
    let deleted_object_value = Object.values(payload.url[payload.url.length-1])[0];
    Vue.delete(state[deleted_object_key], deleted_object_value);
  },
  //parent mutations
  add_wb_object(state, payload){
    let added_object_key = Object.keys(payload.url[payload.url.length-2])[0];
    // let added_object_key = 'wworkpackageimages';
    let parent_key = Object.keys(payload.url[payload.url.length-3])[0];
    let parent_value = Object.values(payload.url[payload.url.length-3])[0];
    if (!state[parent_key][parent_value][added_object_key]) {
        Vue.set(state[parent_key][parent_value], [added_object_key], []);
    }
    if (payload.wb_object.position) {
      state[parent_key][parent_value][added_object_key].splice(payload.wb_object.position-1, 0, payload.resp_data[added_object_key][0].id);
    } else {
      state[parent_key][parent_value][added_object_key].push(payload.resp_data[added_object_key][0].id);
    }
  },
  remove_wb_object(state, payload) {
    let removed_object_key = Object.keys(payload.url[payload.url.length-1])[0];
    let removed_object_value = Object.values(payload.url[payload.url.length-1])[0];
    let parent_key = Object.keys(payload.url[payload.url.length-2])[0];
    let parent_value = Object.values(payload.url[payload.url.length-2])[0];
    let index = state[parent_key][parent_value][removed_object_key].indexOf(removed_object_value);
    state[parent_key][parent_value][removed_object_key].splice(index, 1);
  },
  change_wb_object_position(state, payload) {
    let changed_object_key = Object.keys(payload.url[payload.url.length-2])[0];
    let changed_object_value = Object.values(payload.url[payload.url.length-2])[0];
    let parent_key = Object.keys(payload.url[payload.url.length-3])[0];
    let parent_value = Object.values(payload.url[payload.url.length-3])[0];

    let array = state[parent_key][parent_value][changed_object_key];
    let old_index = array.indexOf(changed_object_value);
    let new_index = array.indexOf(Object.values(payload.target)[0]);

    array.splice(new_index, 0, array.splice(old_index, 1)[0]);
  },
  change_wb_object_parent(state, payload) {
    let changed_object_key = Object.keys(payload.url[payload.url.length-2])[0];
    let changed_object_value = Object.values(payload.url[payload.url.length-2])[0];
    let parent_key = Object.keys(payload.url[payload.url.length-3])[0];
    let old_parent_value = Object.values(payload.url[payload.url.length-3])[0];
    // let new_parent_value = payload.target.target_id;
    let new_parent_value = payload.update.parent_id;

    let old_array = state[parent_key][old_parent_value][changed_object_key];
    let new_array = state[parent_key][new_parent_value][changed_object_key];
    let old_index = old_array.indexOf(changed_object_value);
    // let new_index = payload.target.position;
    let new_index = payload.update.position;

    old_array.splice(old_index, 1);
    new_array.splice(new_index, 0, changed_object_value);
  },
  change_wb_object_folder(state, payload) {
    const wb_object_key = Object.keys(payload.url[0])[0];
    const wb_object_id = Object.values(payload.url[0])[0];
    // console.log('wb_object_key', wb_object_key)
    // console.log('wb_object_id', wb_object_id)
    // console.log('payload', payload)

    // aus altem entfernen
    if (state[wb_object_key][wb_object_id][payload.update.folder_key.substring(0, payload.update.folder_key.length - 1)]) {
      const old_folder_id = state[wb_object_key][wb_object_id][payload.update.folder_key.substring(0, payload.update.folder_key.length - 1)].id;
      const index = state[payload.update.folder_key][old_folder_id][wb_object_key].indexOf(wb_object_id);
      state[payload.update.folder_key][old_folder_id][payload.update.folder_key].splice(index, 1)
    }

    // neuem hinzufügen
    if (payload.update.parent_id === -1) {
      Vue.set(state[wb_object_key][wb_object_id], payload.update.folder_key.substring(0, payload.update.folder_key.length - 1), null)
    } else {
      Vue.set(state[wb_object_key][wb_object_id], payload.update.folder_key.substring(0, payload.update.folder_key.length - 1), state[payload.update.folder_key][payload.update.parent_id])
    }

    // console.log('state folders after change', state.sfolders)

  },
  set_error(state, error) {
    state.error = error;
  },
  set_cache(state, url) {
    state.cache[url] = {
      time_expired: new Date().getTime() + 600000
    };
  },
  add_load_type(state, type){
    state.all_loaded.push(type);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
